import { useUserData } from '../../hooks/useUserData';
import { DEFAULT_IMAGES } from '../../constants/defaults';
import PremiumName from '../ui/PremiumName';

/**
 * PostSuggestion - Componente para mostrar sugerencias de posts con datos de usuario actualizados
 */
const PostSuggestion = ({ post, onClick }) => {
  const { userData } = useUserData(post.userId);

  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors text-left"
    >
      {post.media && post.media[0] && (() => {
        const m = post.media[0];
        const src = typeof m === 'string' ? m : (m.type === 'video' ? (m.thumbnailUrl || DEFAULT_IMAGES.VIDEO_POSTER) : m.url);
        const isVideo = typeof m === 'object' && m.type === 'video';
        return (
          <div className="relative flex-shrink-0">
            <img src={src} alt="" className="w-10 h-10 object-cover rounded" />
            {isVideo && (
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <svg className="w-4 h-4 text-white drop-shadow" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            )}
          </div>
        );
      })()}
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
          {post.caption || 'Sin título'}
        </p>
        <PremiumName
          name={userData?.displayName || post.userName || 'Usuario'}
          isPremium={userData?.isPremium}
          premiumColor={userData?.premiumNameColor}
          nameClassName="text-xs text-gray-500 dark:text-gray-400"
          iconSize="xs"
        />
      </div>
    </button>
  );
};

export default PostSuggestion;
